import { IIsiDtoPresentationLogicResponse } from "./Isilog.IsiComponent.IsiDataTransferObject";
import { IIsiDataTransferObject } from "./Isilog.IsiFramework.IsiDataTransferObject";
import { IsiDataTransferObject } from "./Isilog.IsiFramework.IsiDataTransferObject";
import { IsiDtoPresentationLogicResponse } from "./Isilog.IsiComponent.IsiDataTransferObject";
import { IIsiDtoPresentationLogicRequest } from "./Isilog.IsiComponent.IsiDataTransferObject";
import { IsiDtoPresentationLogicRequest } from "./Isilog.IsiComponent.IsiDataTransferObject";

export interface IIsiDtoPlInstanceScreenResponse extends IIsiDtoPresentationLogicResponse  {
    getInstanceFormulaire?: IIsiDtoPlInstanceFormResult;
    getNbDroitValue?: number;
    getNbDroitResult?: IIsiDtoPlInstanceScreenResult;
    getNbDroitModifValue?: number;
    getNbDroitModifResult?: IIsiDtoPlInstanceScreenResult;
    getVTInstanceValue?: string;
    getVTInstanceResult?: IIsiDtoPlInstanceScreenResult;
    getNbDroitVTValue?: number;
    getNbDroitVTResult?: IIsiDtoPlInstanceScreenResult;
    getNbAllVTValue?: number;
    getNbAllVTResult?: IIsiDtoPlInstanceScreenResult;
}
export interface IIsiDtoPlInstanceFormResult extends IIsiDataTransferObject  {
    moreOneInstance?: boolean;
    instanceFormResult?: string;
}
export class IsiDtoPlInstanceFormResult extends IsiDataTransferObject implements IIsiDtoPlInstanceFormResult {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.InstanceScreen.IsiDtoPlInstanceFormResult, Isilog.IsiComponent.IsiDataTransferObject";
    moreOneInstance?: boolean;
    instanceFormResult?: string;

    constructor(data?: IIsiDtoPlInstanceFormResult) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.moreOneInstance = _data["moreOneInstance"] !== undefined ? _data["moreOneInstance"] : false;
            this.instanceFormResult = _data["instanceFormResult"] !== undefined ? _data["instanceFormResult"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoPlInstanceFormResult): IsiDtoPlInstanceFormResult {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoPlInstanceFormResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["moreOneInstance"] = this.moreOneInstance !== undefined ? this.moreOneInstance : false;
        data["instanceFormResult"] = this.instanceFormResult !== undefined ? this.instanceFormResult : <any>null;
        return data;
    }
}
export interface IIsiDtoPlInstanceScreenResult extends IIsiDataTransferObject  {
    instanceScreenResult?: string;
}
export class IsiDtoPlInstanceScreenResult extends IsiDataTransferObject implements IIsiDtoPlInstanceScreenResult {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.InstanceScreen.IsiDtoPlInstanceScreenResult, Isilog.IsiComponent.IsiDataTransferObject";
    instanceScreenResult?: string;

    constructor(data?: IIsiDtoPlInstanceScreenResult) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.instanceScreenResult = _data["instanceScreenResult"] !== undefined ? _data["instanceScreenResult"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoPlInstanceScreenResult): IsiDtoPlInstanceScreenResult {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoPlInstanceScreenResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["instanceScreenResult"] = this.instanceScreenResult !== undefined ? this.instanceScreenResult : <any>null;
        return data;
    }
}
export class IsiDtoPlInstanceScreenResponse extends IsiDtoPresentationLogicResponse implements IIsiDtoPlInstanceScreenResponse {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.PresentationLogic.InstanceScreen.IsiDtoPlInstanceScreenResponse, Isilog.IsiComponent.IsiDataTransferObject";
    getInstanceFormulaire?: IsiDtoPlInstanceFormResult;
    getNbDroitValue?: number;
    getNbDroitResult?: IsiDtoPlInstanceScreenResult;
    getNbDroitModifValue?: number;
    getNbDroitModifResult?: IsiDtoPlInstanceScreenResult;
    getVTInstanceValue?: string;
    getVTInstanceResult?: IsiDtoPlInstanceScreenResult;
    getNbDroitVTValue?: number;
    getNbDroitVTResult?: IsiDtoPlInstanceScreenResult;
    getNbAllVTValue?: number;
    getNbAllVTResult?: IsiDtoPlInstanceScreenResult;

    constructor(data?: IIsiDtoPlInstanceScreenResponse) {
        super(data);
        if (data) {
            this.getInstanceFormulaire = data.getInstanceFormulaire && !(<any>data.getInstanceFormulaire).toJSON ? new IsiDtoPlInstanceFormResult(data.getInstanceFormulaire) : <IsiDtoPlInstanceFormResult>this.getInstanceFormulaire;
            this.getNbDroitResult = data.getNbDroitResult && !(<any>data.getNbDroitResult).toJSON ? new IsiDtoPlInstanceScreenResult(data.getNbDroitResult) : <IsiDtoPlInstanceScreenResult>this.getNbDroitResult;
            this.getNbDroitModifResult = data.getNbDroitModifResult && !(<any>data.getNbDroitModifResult).toJSON ? new IsiDtoPlInstanceScreenResult(data.getNbDroitModifResult) : <IsiDtoPlInstanceScreenResult>this.getNbDroitModifResult;
            this.getVTInstanceResult = data.getVTInstanceResult && !(<any>data.getVTInstanceResult).toJSON ? new IsiDtoPlInstanceScreenResult(data.getVTInstanceResult) : <IsiDtoPlInstanceScreenResult>this.getVTInstanceResult;
            this.getNbDroitVTResult = data.getNbDroitVTResult && !(<any>data.getNbDroitVTResult).toJSON ? new IsiDtoPlInstanceScreenResult(data.getNbDroitVTResult) : <IsiDtoPlInstanceScreenResult>this.getNbDroitVTResult;
            this.getNbAllVTResult = data.getNbAllVTResult && !(<any>data.getNbAllVTResult).toJSON ? new IsiDtoPlInstanceScreenResult(data.getNbAllVTResult) : <IsiDtoPlInstanceScreenResult>this.getNbAllVTResult;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.getInstanceFormulaire = _data["getInstanceFormulaire"] ? IsiDtoPlInstanceFormResult.fromJS(_data["getInstanceFormulaire"]) : <any>null;
            this.getNbDroitValue = _data["getNbDroitValue"] !== undefined ? _data["getNbDroitValue"] : 0;
            this.getNbDroitResult = _data["getNbDroitResult"] ? IsiDtoPlInstanceScreenResult.fromJS(_data["getNbDroitResult"]) : <any>null;
            this.getNbDroitModifValue = _data["getNbDroitModifValue"] !== undefined ? _data["getNbDroitModifValue"] : 0;
            this.getNbDroitModifResult = _data["getNbDroitModifResult"] ? IsiDtoPlInstanceScreenResult.fromJS(_data["getNbDroitModifResult"]) : <any>null;
            this.getVTInstanceValue = _data["getVTInstanceValue"] !== undefined ? _data["getVTInstanceValue"] : <any>null;
            this.getVTInstanceResult = _data["getVTInstanceResult"] ? IsiDtoPlInstanceScreenResult.fromJS(_data["getVTInstanceResult"]) : <any>null;
            this.getNbDroitVTValue = _data["getNbDroitVTValue"] !== undefined ? _data["getNbDroitVTValue"] : 0;
            this.getNbDroitVTResult = _data["getNbDroitVTResult"] ? IsiDtoPlInstanceScreenResult.fromJS(_data["getNbDroitVTResult"]) : <any>null;
            this.getNbAllVTValue = _data["getNbAllVTValue"] !== undefined ? _data["getNbAllVTValue"] : 0;
            this.getNbAllVTResult = _data["getNbAllVTResult"] ? IsiDtoPlInstanceScreenResult.fromJS(_data["getNbAllVTResult"]) : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoPlInstanceScreenResponse): IsiDtoPlInstanceScreenResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoPlInstanceScreenResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["getInstanceFormulaire"] = this.getInstanceFormulaire != null ? (<any>this.getInstanceFormulaire).toJSON() : <any>null;
        data["getNbDroitValue"] = this.getNbDroitValue !== undefined ? this.getNbDroitValue : 0;
        data["getNbDroitResult"] = this.getNbDroitResult != null ? (<any>this.getNbDroitResult).toJSON() : <any>null;
        data["getNbDroitModifValue"] = this.getNbDroitModifValue !== undefined ? this.getNbDroitModifValue : 0;
        data["getNbDroitModifResult"] = this.getNbDroitModifResult != null ? (<any>this.getNbDroitModifResult).toJSON() : <any>null;
        data["getVTInstanceValue"] = this.getVTInstanceValue !== undefined ? this.getVTInstanceValue : <any>null;
        data["getVTInstanceResult"] = this.getVTInstanceResult != null ? (<any>this.getVTInstanceResult).toJSON() : <any>null;
        data["getNbDroitVTValue"] = this.getNbDroitVTValue !== undefined ? this.getNbDroitVTValue : 0;
        data["getNbDroitVTResult"] = this.getNbDroitVTResult != null ? (<any>this.getNbDroitVTResult).toJSON() : <any>null;
        data["getNbAllVTValue"] = this.getNbAllVTValue !== undefined ? this.getNbAllVTValue : 0;
        data["getNbAllVTResult"] = this.getNbAllVTResult != null ? (<any>this.getNbAllVTResult).toJSON() : <any>null;
        return data;
    }
}
export interface IIsiDtoPlInstanceScreenRequest extends IIsiDtoPresentationLogicRequest  {
    response?: IIsiDtoPlInstanceScreenResponse;
    listInstancesAdd?: string[];
    evaluatedValue?: string;
    controlId?: string;
    listDroitModif?: string[];
    listInstanceVTAdd?: string[];
    nbInstanceVTAddCount?: number;
    nbInstVTAllCount?: number;
    codeEcranListe?: string;
    codeEcran?: string;
}
export class IsiDtoPlInstanceScreenRequest extends IsiDtoPresentationLogicRequest implements IIsiDtoPlInstanceScreenRequest {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.PresentationLogic.InstanceScreen.IsiDtoPlInstanceScreenRequest, Isilog.IsiComponent.IsiDataTransferObject";
    response?: IsiDtoPlInstanceScreenResponse;
    listInstancesAdd?: string[];
    evaluatedValue?: string;
    controlId?: string;
    listDroitModif?: string[];
    listInstanceVTAdd?: string[];
    nbInstanceVTAddCount?: number;
    nbInstVTAllCount?: number;
    codeEcranListe?: string;
    codeEcran?: string;

    constructor(data?: IIsiDtoPlInstanceScreenRequest) {
        super(data);
        if (data) {
            this.response = data.response && !(<any>data.response).toJSON ? new IsiDtoPlInstanceScreenResponse(data.response) : <IsiDtoPlInstanceScreenResponse>this.response;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.response = _data["response"] ? IsiDtoPlInstanceScreenResponse.fromJS(_data["response"]) : <any>null;
            this.listInstancesAdd = _data["listInstancesAdd"];
            this.evaluatedValue = _data["evaluatedValue"] !== undefined ? _data["evaluatedValue"] : <any>null;
            this.controlId = _data["controlId"] !== undefined ? _data["controlId"] : <any>null;
            this.listDroitModif = _data["listDroitModif"];
            this.listInstanceVTAdd = _data["listInstanceVTAdd"];
            this.nbInstanceVTAddCount = _data["nbInstanceVTAddCount"] !== undefined ? _data["nbInstanceVTAddCount"] : null;
            this.nbInstVTAllCount = _data["nbInstVTAllCount"] !== undefined ? _data["nbInstVTAllCount"] : null;
            this.codeEcranListe = _data["codeEcranListe"] !== undefined ? _data["codeEcranListe"] : <any>null;
            this.codeEcran = _data["codeEcran"] !== undefined ? _data["codeEcran"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoPlInstanceScreenRequest): IsiDtoPlInstanceScreenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoPlInstanceScreenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["response"] = this.response != null ? (<any>this.response).toJSON() : <any>null;
        data["listInstancesAdd"] = this.listInstancesAdd !== undefined ? this.listInstancesAdd : [];
        data["evaluatedValue"] = this.evaluatedValue !== undefined ? this.evaluatedValue : <any>null;
        data["controlId"] = this.controlId !== undefined ? this.controlId : <any>null;
        data["listDroitModif"] = this.listDroitModif !== undefined ? this.listDroitModif : [];
        data["listInstanceVTAdd"] = this.listInstanceVTAdd !== undefined ? this.listInstanceVTAdd : [];
        data["nbInstanceVTAddCount"] = this.nbInstanceVTAddCount !== undefined ? this.nbInstanceVTAddCount : null;
        data["nbInstVTAllCount"] = this.nbInstVTAllCount !== undefined ? this.nbInstVTAllCount : null;
        data["codeEcranListe"] = this.codeEcranListe !== undefined ? this.codeEcranListe : <any>null;
        data["codeEcran"] = this.codeEcran !== undefined ? this.codeEcran : <any>null;
        return data;
    }
}
